<div class="alert">
    <div class="outline">
        <mat-icon>priority_high</mat-icon>
    </div>
    <h2>Confirmación</h2>
    <span>{{confirmMessage}}</span>
</div>
<br>
<mat-grid-list cols="2" rowHeight="40px" gutterSize="6px">
    <mat-grid-tile [colspan]="1" class="grid">
        <button mat-raised-button color="warn" (click)="_dialogRef.close(false)" class="boton">No</button>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="1" class="grid">
        <button mat-button (click)="_dialogRef.close(true)" class="close-button">Si</button>
    </mat-grid-tile>
</mat-grid-list>